import { render, staticRenderFns } from "./PostDetailView.vue?vue&type=template&id=5c215599&scoped=true&"
import script from "./PostDetailView.vue?vue&type=script&lang=js&"
export * from "./PostDetailView.vue?vue&type=script&lang=js&"
import style0 from "./PostDetailView.vue?vue&type=style&index=0&id=5c215599&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c215599",
  null
  
)

export default component.exports